<template>
  <vs-row vs-type="flex" vs-w="12" v-if=" parent != null && parent.length > 0" class="variant-row pl-5 pt-1 pb-1"
          style="overflow-x:hidden;">
    <vs-row vs-type="flex" vs-w="12" v-for="(variant) in parent" :key="variant.id">
      <span @click="onClick(variant)" class="bg-secondary variant w-full flex align-center">
        <vs-button v-if="variant.children != null && variant.children.length > 0" size="small" color="transparent p-0"
                   class="text-primary" icon-pack="feather"
                   :icon="variant.isExpand ? 'icon-minus' : 'icon-plus'"></vs-button>
        <p class="text-primary variant-name mr-5" :class="{'variant-expanded' : variant.isExpand}">
          {{variant.name}} - {{variant.type}}  {{variant.price!=null?(" - "+ $toCurrency(variant.price)):("")}}
        </p>
        <vs-button v-if="variant.type!='variant'" @click="addVariant(variant.id,variant.name)" size="medium"
                   icon-pack="feather" icon="icon-plus"
                   type="gradient" class="ml-5"></vs-button>
        <vs-button @click="deleteVariant(variant.id)" size="medium" icon-pack="feather" icon="icon-trash" color="danger"
                   type="gradient" class="ml-2">
        </vs-button>
        <vs-button @click="editVariant(variant)" size="medium" icon-pack="feather" icon="icon-edit" color="secondary"
                   type="gradient" class="ml-2">
        </vs-button>
        <!-- <vx-tooltip text="Şube Bazlı Fiyat Düzenleme" position="top">
        <vs-button v-if="variant.price!=null" @click="setBranchProductPrice(variant)" size="medium" icon-pack="feather" icon="icon-branches" color="secondary"
                   type="gradient" class="ml-2">
        </vs-button>
      </vx-tooltip> -->
      </span>
      <transition name="slide-fade">
        <child-variant v-show="variant.isExpand"
                       v-if="variant.children != null && variant.children.length > 0"
                       :child="variant.children" :parentRefsChild="parentRefs"/>
      </transition>
    </vs-row>
  </vs-row>
</template>

<script>
  export default {
    props: {
      parent: {
        type: Array,
        required: true
      },
      parentRefs: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        newVariant: {},
        isNew: false,
        isClose: true,
      };
    },
    methods: {
      addVariant(rootVariantId, rootVariantName) {
        this.parentRefs.newVariantAdd.isActive = true;
        this.parentRefs.newVariantAdd.newVariant = {
          rootId: rootVariantId
        };
        this.parentRefs.newVariantAdd.rootName = rootVariantName;
      },
      onClick(variant) {
        variant.isExpand = !variant.isExpand;
      },
      deleteVariant(variantId) {
        this.parentRefs.newVariantAdd.deleteId = variantId;
      },
      editVariant(variant) {
        this.parentRefs.newVariantAdd.isActive = true;
        this.parentRefs.newVariantAdd.newVariant = _.cloneDeep(variant);
      },
      setBranchProductPrice(variant) {
        this.parentRefs.newBranchProductPrice.isActive = true;
        this.parentRefs.newBranchProductPrice.newPrice = _.cloneDeep(variant);
      }
    },
    mounted() {
    },
    components: {
      ChildVariant: () => import("./childVariant.vue")
    },
  };

</script>
<style>
  .variant-row div span button i {
    font-weight: 600 !important;
    font-size: 1.35rem !important;
  }

  button.vs-component.vs-button.text-primary.vs-button-null.vs-button-filled.includeIcon.includeIconOnly.small {
    padding: 4px !important;
  }
</style>
